const CURRENCY_PREFIX = 'R$ '
const CENTS_DIVISOR = 100

const formatCurrencyNumber = (value: number): string => {
  return `${CURRENCY_PREFIX}${value.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`
}

export const extractDigits = (value: string): string => value.replace(/\D/g, '')

export const formatCurrencyFromDigits = (rawDigits: string): string => {
  const digits = extractDigits(rawDigits)
  const parsed = Number(digits || '0')

  if (Number.isNaN(parsed)) return formatCurrencyNumber(0)
  return formatCurrencyNumber(parsed / CENTS_DIVISOR)
}

export const parseCurrencyInputToNumber = (maskedValue: string): number | null => {
  const digits = extractDigits(maskedValue)
  if (!digits) return null

  const parsed = Number(digits) / CENTS_DIVISOR
  if (Number.isNaN(parsed) || parsed <= 0) return null

  return parsed
}

export const EMPTY_CURRENCY_VALUE = formatCurrencyNumber(0)
